import { Command } from 'commander'
import pc from 'picocolors'
import { buildCommand } from './commands/build'
import { initCommand } from './commands/init'
import { devCommand } from './commands/dev'
import { deployCommand } from './commands/deploy'

const VERSION = '0.0.1'

const program = new Command()

program
  .name('brixon')
  .description('CLI for building Brixon presentations')
  .version(VERSION, '-v, --version', 'Output the current version')

// Register commands
program.addCommand(buildCommand)
program.addCommand(initCommand)
program.addCommand(devCommand)
program.addCommand(deployCommand)

// Error handling
program.exitOverride((err) => {
  if (err.code === 'commander.helpDisplayed' || err.code === 'commander.version') {
    process.exit(0)
  }
  console.error(pc.red(`Error: ${err.message}`))
  process.exit(1)
})

// Parse arguments
program.parse(process.argv)

// Show help if no command provided
if (process.argv.length === 2) {
  program.help()
}
